(function () {
  let cartData = null;
  let refreshTimer = null;
  let discObserver = null;

  // ── Fetch cart.js ──────────────────────────────────────────────────────────

  async function fetchCart() {
    const r  = await fetch('/cart.js?_=' + Date.now());
    cartData = await r.json();

    cartData.items.forEach(item => {
      const cb = document.querySelector(`.cart-item-checkbox[data-key="${CSS.escape(item.key)}"]`);
      if (!cb) return;
      cb.dataset.linePrice     = item.final_line_price;
      cb.dataset.originalPrice = item.original_line_price;
    });
  }

  // ── Helpers ────────────────────────────────────────────────────────────────

  function getAll()     { return [...document.querySelectorAll('.cart-item-checkbox')]; }
  function getChecked() { return [...document.querySelectorAll('.cart-item-checkbox:checked')]; }

  function fmt(cents) {
    return 'Rp\u00a0' + Math.round(cents / 100).toLocaleString('id-ID');
  }

  // Format khusus Discountify (pakai koma, prefix IDR)
  function fmtDisc(cents) {
    return 'IDR ' + Math.round(cents / 100).toLocaleString('en-US');
  }

  // ── Kalkulasi total selected ───────────────────────────────────────────────

// ── REPLACE calcSelected() ────────────────────────────────────────────────────

function calcSelected() {
  const checked = getChecked();

  let final    = 0;
  let original = 0;

  // Build map dari cartData biar O(1) lookup
  const cartMap = cartData?.items
    ? new Map(cartData.items.map(i => [i.key, i]))
    : new Map();

  checked.forEach(cb => {
    const item = cartMap.get(cb.dataset.key);

    if (item) {
      // Data fresh dari /cart.js — paling akurat
      final    += item.final_line_price;
      original += item.original_line_price;
    } else {
      // Fallback: item baru ditambah, belum ada di cartData
      // Pakai data-attribute dari Liquid (harga tanpa diskon)
      const lp = parseInt(cb.dataset.linePrice     || 0);
      const op = parseInt(cb.dataset.originalPrice || cb.dataset.linePrice || 0);
      final    += lp;
      original += op;
    }
  });

  return { final, original, discount: Math.max(0, original - final), count: checked.length };
}

  // ── Update checkout button ─────────────────────────────────────────────────

  function renderButton() {
    const el  = document.getElementById('drawer-selected-total');
    const btn = document.getElementById('cart-drawer-checkout-btn');
    if (!el) return;

    const { final, original, count } = calcSelected();

    if (count === 0) {
      el.textContent    = fmt(0);
      if (btn) btn.disabled      = true;
      if (btn) btn.style.opacity = '0.5';
      return;
    }

    el.innerHTML = original > final
      ? `<del style="opacity:0.42;font-size:0.8em;font-weight:400">${fmt(original)}</del>&nbsp;${fmt(final)}`
      : fmt(final);

    if (btn) { btn.disabled = false; btn.style.opacity = '1'; btn.style.cursor = ''; }
  }

  // ── Update Discountify widget DOM ──────────────────────────────────────────

  function updateDiscountifyWidget() {
    const hasDiscount = !!document.querySelector('input.discountApplied')?.value?.trim();
    const subtotalEl  = document.querySelector('.spn_fin_subtot');
    const totalEl     = document.querySelector('.spn_fin_tot');
    const discountEl  = document.querySelector('.spn_dis_dt');

    if (!subtotalEl || !totalEl || !discountEl) return;

    const { final, original, discount } = calcSelected();

    // Disconnect observer dulu biar ga loop
    discObserver?.disconnect();

    if (!hasDiscount) {
      // Kalau ga ada diskon, tampilkan subtotal aja
      subtotalEl.textContent = fmtDisc(original);
      totalEl.textContent    = ' ' + fmtDisc(original);
      discountEl.textContent = fmtDisc(0);
    } else {
      subtotalEl.textContent = fmtDisc(original);
      totalEl.textContent    = ' ' + fmtDisc(final);
      discountEl.textContent = fmtDisc(discount);

      // Update badge diskon di tag (- IDR xxx)
      document.querySelectorAll('.cpn_dcnt_price').forEach(el => {
        if (el.closest('.cpn_tag_wrap') || el.textContent.includes('-')) return;
        // Skip yang berisi tombol close
        if (el.querySelector('button')) return;
      });

      // Update di tag cpn_tag_wrap
      const tagPrice = document.querySelector('.cpn_tag_wrap .cpn_dcnt_price');
      if (tagPrice) tagPrice.textContent = '- ' + fmtDisc(discount);
    }

    // Reconnect setelah update
    setTimeout(() => watchDiscountify(), 150);
  }

  // ── Update semua ──────────────────────────────────────────────────────────

  function update() {
    // Grayout visual
    getAll().forEach(cb => {
      cb.closest('.product-cart-item')
        ?.classList.toggle('cart-item-unselected', !cb.checked);
    });

    // Select-all state + count
    const all     = getAll();
    const checked = getChecked();
    const sa      = document.getElementById('cart-select-all');
    const count   = document.getElementById('cart-select-count');

    if (sa) {
      sa.checked       = all.length > 0 && checked.length === all.length;
      sa.indeterminate = checked.length > 0 && checked.length < all.length;
    }
    if (count) count.textContent = `${checked.length}/${all.length}`;

    // Update button + Discountify widget
    renderButton();
    updateDiscountifyWidget();
  }

  // ── Inject select-all ──────────────────────────────────────────────────────

  function injectSelectAll() {
    if (document.getElementById('cart-select-all-row')) return;
    const wrap = document.querySelector('.product-cart-item--container');
    if (!wrap) return;

    const row = document.createElement('div');
    row.id        = 'cart-select-all-row';
    row.className = 'cart-select-all-row';
    row.innerHTML = `
      <label class="cart-select-all-label">
        <input type="checkbox" id="cart-select-all" checked>
        <span>Pilih Semua &bull; <span id="cart-select-count">${getAll().length}/${getAll().length}</span></span>
      </label>`;
    wrap.prepend(row);
  }

  // ── Watch Discountify: re-fetch + update saat diskon berubah ───────────────

  function watchDiscountify() {
    const target = document.querySelector('.discountify_discount_wrap');
    if (!target) return;

    discObserver = new MutationObserver(() => {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(async () => {
        await fetchCart();      // ambil harga terbaru dari Shopify
        renderButton();
        updateDiscountifyWidget();
      }, 700);
    });

    discObserver.observe(target, {
      childList:     true,
      subtree:       true,
      characterData: true,
      attributes:    true
    });
  }

  // ── TAMBAH watchCartItems() — taruh setelah watchDiscountify() ────────────────

function watchCartItems() {
  const container = document.querySelector('.product-cart-item--container');
  if (!container) return;

  new MutationObserver(async (mutations) => {
    const hasNew = mutations.some(m =>
      [...m.addedNodes].some(n =>
        n.nodeType === 1 && (
          n.classList?.contains('product-cart-item') ||
          n.querySelector?.('.product-cart-item')
        )
      )
    );
    if (!hasNew) return;

    // Item baru masuk — re-fetch cart biar cartData fresh
    await fetchCart();
    injectSelectAll();
    update();
  }).observe(container, { childList: true });
}

  // ── Checkout ───────────────────────────────────────────────────────────────

  function checkout() {
    const checked = getChecked();
    if (!checked.length) return;

    const items    = checked.map(cb => `${cb.dataset.variant}:${cb.dataset.qty}`).join(',');
    const discount = document.querySelector('input.discountApplied')?.value?.trim() || '';
    const url      = `/cart/${items}` + (discount ? `?discount=${encodeURIComponent(discount)}` : '');

    window.location.href = url;
  }

  // ── Events ─────────────────────────────────────────────────────────────────

  function bindEvents() {
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('cart-item-checkbox')) update();

      if (e.target.id === 'cart-select-all') {
        getAll().forEach(cb => { cb.checked = e.target.checked; });
        update();
      }
    });

    document.addEventListener('click', (e) => {
      if (e.target.closest('#cart-drawer-checkout-btn')) {
        e.preventDefault();
        e.stopPropagation();
        checkout();
      }
    });

 // ── UPDATE event listener cart:refresh — tambah watchCartItems() ──────────────

['line-item:change:end', 'cart:refresh'].forEach(ev => {
  document.addEventListener(ev, () => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(async () => {
      await fetchCart();
      injectSelectAll();
      update();
      watchDiscountify();
      watchCartItems(); // ← tambah ini juga
    }, 450);
  });
});
  }

  // ── Start ──────────────────────────────────────────────────────────────────

 // ── UPDATE start() — tambah watchCartItems() ──────────────────────────────────

async function start() {
  if (!document.getElementById('Cart-Drawer')) return;

  await fetchCart();
  injectSelectAll();
  update();
  bindEvents();
  watchDiscountify();
  watchCartItems(); // ← tambah ini
}

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start)
    : start();

})();